/**
 * /suprimentos/gestao-solicitacoes — Gestão de Solicitações (gestor).
 *
 * Router-shell autocontido com 3 abas:
 *   (index)        -> Solicitações (tabela/kanban + detalhe + lote MDF)
 *   /lotes         -> Lotes gerados (histórico + download do .xls do otimizador)
 *   /configuracoes -> catálogos de classificação, prazos por rota e regras
 *
 * Cabeçalho compacto (título + abas na mesma linha): a vista kanban ocupa
 * a altura restante da tela, então cada pixel do topo conta.
 */
import React from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";

import { useAuth } from "../../../context/AuthContext";
import { PERMS_GESTAO_SOLICITACOES } from "../../../services/solicitacoes";
import { PageContainer, TabButton, Tabs } from "../../../styles/shared";
import ConfiguracoesTab from "./Configuracoes";
import LotesTab from "./LotesTab";
import SolicitacoesTab from "./SolicitacoesTab";
import { HeaderCompacto } from "./styles";

const BASE = "/suprimentos/gestao-solicitacoes";

export default function GestaoSolicitacoes() {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPermission, hasAnyPermission } = useAuth();
  // Aba "Lotes gerados" só pra quem gera lote (mesma perm das ações da aba).
  const podeLotes = hasPermission("solicitacao:gerar_lote");
  const emLotes = location.pathname.startsWith(`${BASE}/lotes`);
  // Configurações: quem gere LÊ; só `solicitacao:configurar` altera (a aba
  // aparece para os dois — o backend tem o mesmo gate de leitura,
  // `eh_gestor`, que conta também a gestão por tipo).
  const podeConfig =
    hasPermission("solicitacao:configurar") ||
    hasAnyPermission(PERMS_GESTAO_SOLICITACOES);
  const emConfig = location.pathname.startsWith(`${BASE}/configuracoes`);

  return (
    <PageContainer style={{ gap: 12, maxWidth: "none" }}>
      <HeaderCompacto>
        <h1 title="Assistências e requisições internas — ASM · AST · ASP · RQA · RQI">
          Gestão de Solicitações
        </h1>
        <Tabs style={{ margin: 0 }}>
          <TabButton type="button" $active={!emLotes && !emConfig} onClick={() => navigate(BASE)}>
            Solicitações
          </TabButton>
          {podeLotes && (
            <TabButton type="button" $active={emLotes} onClick={() => navigate(`${BASE}/lotes`)}>
              Lotes gerados
            </TabButton>
          )}
          {podeConfig && (
            <TabButton type="button" $active={emConfig} onClick={() => navigate(`${BASE}/configuracoes`)}>
              Configurações
            </TabButton>
          )}
        </Tabs>
      </HeaderCompacto>

      <Routes>
        <Route index element={<SolicitacoesTab />} />
        {podeLotes && <Route path="lotes" element={<LotesTab />} />}
        {podeConfig && <Route path="configuracoes" element={<ConfiguracoesTab />} />}
        <Route path="*" element={<Navigate to={BASE} replace />} />
      </Routes>
    </PageContainer>
  );
}
